// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AmountControl_wrapper__zAnUK","column":"AmountControl_column__30kSN","plus":"AmountControl_plus__3MLo4","minus":"AmountControl_minus__2pZLY"};